<template>
  <div class="footerNav">
    <div class="footerNav-background">
      <img :src="background" />
    </div>
    <div class="footerNav-content">
      <div class="footerNav-content-left">
        <div class="footerLogo">
          <img :src="footerLogo" />
        </div>
        <div class="footerList">
          <div class="footerList-top">
            <ul v-for="item in footerList">
              <li>
                <span>{{item.name}}</span>
              </li>
              <li v-for="list in item.children" v-if="list.show">
                <i :class="list.icon"></i>
                <span>{{list.content}}</span>
              </li>
              <li v-for="list in item.children" v-else @click="$router.push({name:list.link})">
                <span>{{list.name}}</span>
              </li>
            </ul>
          </div>
          <div class="footerList-bottom">
            <ul v-for="item in friendLinks">
              <li>
                <span>{{item.name}}</span>
              </li>
              <li v-for="list in item.children" @click="openLinks('www.baidu.com')">
                <span>{{list}}</span>
              </li>
            </ul>
            <ul>
              <li>{{copyright}}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footerNav-content-right">
        <img :src="motto" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterNav",
  data() {
    return {
      background: require("@/assets/footerBg.png"),
      motto: require("@/assets/motto.png"),
      footerLogo: require("@/assets/footerLogo.png"),
      //便捷入口 联系我们
      footerList: [
        {
          name: "快速入口",
          children: [
            {
              name: "学校黄页",
              show: false,
              link: "NewsCenter"
            },
            {
              name: "开放平台",
              show: false,
              link: "NewsCenter"
            },
            {
              name: "帮助中心",
              show: false,
              link: "NewsCenter"
            }
          ]
        },
        {
          name: "联系我们",
          children: [
            {
              show: true,
              icon: "el-icon-phone-outline",
              content: "86-21-54740000 // 86-21-54760000"
            },
            {
              show: true,
              icon: "el-icon-location-outline",
              content: "西安市鼓楼区XXXXXXX219号"
            }
          ]
        }
      ],
      //友情链接
      friendLinks: [
        {
          name: "友情链接：",
          children: [
            "学校主页",
            "图书馆",
            "研究生网",
            "校园地图",
            "继续教育网",
            "院系专业",
            "新媒体管理",
            "国际合作",
            "继续教育网",
            "院系专业",
            "新媒体管理",
            "国际合作",
            "院系专业"
          ]
        }
      ],
      //版权
      copyright:"沪ICP备05052060 沪举报中心 沪公安网备31009102000045 版权所有©某某大学"
    }
  },
  methods: {
    //点击友情链接
    openLinks(link) {
      window.open(link);
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";
$footer-height: 230px;
.footerNav {
  width: 100vw;
  min-height: $footer-height;
  overflow: hidden;
  position: relative;
  background-color: $color-primary;
  &-background {
    width: 100vw;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.7);
    position: absolute;
    img {
      width: 100%;
    }
  }
  &-content {
    position: relative;
    width: calc(100vw - 260px);
    min-height: $footer-height;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-left {
      display: flex;
      align-items: center;
      .footerList {
        border-left: 1px solid #ffffff;
        min-height: 130px;
        margin-left: 40px;
        padding-left: 40px;
        &-top {
          border-bottom: 1px solid #ffffff;
          ul {
            margin: 0;
            margin-bottom: 15px;
            overflow: hidden;
            li {
                float: left;
              color: rgba($color: #ffffff, $alpha: 0.79);
              font-size: 12px;
              margin-right: 50px;
              span {
                vertical-align: top;
              }
              &:nth-child(1) {
                color: rgba($color: #ffffff, $alpha: 1);
                font-size: 14px;
                margin-right: 38px;
              }
            }
            &:nth-child(1) {
              li:nth-child(n + 2) {
                cursor: pointer;
              }
            }
            &:nth-child(2) {
              li {
                margin-right: 30px;
                i {
                  margin-right: 7px;
                }
              }
            }
          }
        }
        &-bottom {
          ul {
            overflow: hidden;
            margin-top: 15px;
            li {
                float: left;
              font-size: 12px;
              padding: 0 16px;
              color: rgba($color: #ffffff, $alpha: 0.79);
              border-right: 1px solid rgba($color: #ffffff, $alpha: 0.79);
              &:nth-child(1) {
                padding: 0;
                border: none;
              }
              &:nth-last-child(1) {
                border: none;
              }
            }
            &:nth-child(1){
                li:nth-child(n+2){
                    cursor: pointer;
                }
            }
          }
        }
      }
    }
    &-right {
    }
  }
}
</style>